import { render, staticRenderFns } from "./SubmitNotification.vue?vue&type=template&id=7903d6a5&scoped=true"
import script from "./SubmitNotification.vue?vue&type=script&lang=js"
export * from "./SubmitNotification.vue?vue&type=script&lang=js"
import style0 from "./SubmitNotification.vue?vue&type=style&index=0&id=7903d6a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7903d6a5",
  null
  
)

export default component.exports